<template>
    <v-container class="pa-2" fluid grid-list-sm >  
        <div v-if="getShowModalMessageResult">{{processModalResult()}}</div>

        <v-card class="app-page-card shadow-none" v-if="content">
            <v-card-title>
            Groups
            </v-card-title>
            <v-card-text v-if="!content.permissions"> No permissions  </v-card-text>
            <v-card-text v-if="content.permissions"> 
                <v-row >
                    <v-col cols="6">
                        <v-card >
                            <v-card-text>
                                <h3>My (created) groups</h3>
                                <br>
                                <v-row> 
                                    <v-col cols=4><b>Group name</b></v-col>
                                    <v-col cols=2><b>Group key</b></v-col>
                                    <v-col cols=2><b>Key for teachers</b></v-col>
                                    <v-col cols=4><v-checkbox v-model="selectedArchivedCreated" label = "show archived"></v-checkbox></v-col>
                                </v-row>
                                <div v-for="(group, index) in content.created_groups" :key="index">
                                    <v-row v-if="!group.archived || selectedArchivedCreated">
                                        <v-col cols=4>{{group.group_name}}<span v-if="group.archived"> (archived)</span></v-col>
                                        <v-col cols=2 v-if="show_key != group.id" @click="show_key = show_key>-1?-1:group.id">
                                            <v-icon title="Show key">mdi-eye-outline</v-icon>
                                        </v-col>                                        
                                        <v-col cols=2 v-if="show_key == group.id">
                                            {{group.group_key}} <v-icon @click="show_key =-1">close</v-icon>
                                        </v-col>                                        
                                        <v-col cols=2 v-if="show_teacher_key != group.id" @click="show_teacher_key = show_teacher_key>-1?-1:group.id">
                                            <v-icon title="Show teacher key">mdi-eye-outline</v-icon>
                                        </v-col>                                        
                                        <v-col cols=2 v-if="show_teacher_key == group.id">
                                            {{group.teacher_key}} <v-icon @click="show_teacher_key =-1">close</v-icon>
                                        </v-col>                                        
                                        <v-col cols=4>
                                            <v-icon @click="processed_group = Object.assign({},group); edit_group = index;">edit</v-icon>
                                            <v-icon @click="tryDeleteGroup(group)">delete</v-icon>
                                            <v-btn class="background-transparent" x-small dense @click="startTeaching(group)">teach it</v-btn>
                                            <v-btn class="background-transparent" x-small dense @click="archiveGroup('created',group)">
                                                <span v-if="!group.archived">archive</span>
                                                <span v-if="group.archived">unarchive</span>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row cols=12 v-if="edit_group == index">
                                        <v-card>
                                            <v-card-title>Group edit <v-icon class="btn-close" @click="edit_group = -1"> close</v-icon> </v-card-title>
                                            <v-card-text>
                                                <v-row>
                                                    <v-col cols=4><v-text-field :rules="sizeRules" label="Name" v-model="processed_group.group_name"></v-text-field></v-col>
                                                    <v-col cols=3><v-text-field :rules="sizeRules" label="Group key" v-model="processed_group.group_key"></v-text-field></v-col>
                                                    <v-col cols=3><v-text-field :rules="sizeRules" label="Teacher key" v-model="processed_group.teacher_key"></v-text-field></v-col>     
                                                    <v-col cols=1><v-icon x-large color="green" @click="processGroup(index)">done</v-icon></v-col>  
                                                </v-row>
                                            </v-card-text>
                                        </v-card>                                          
                                    </v-row>
                                </div>
                                <br>
                                <v-card v-if="edit_group ==-2">
                                    <v-card-title>New group <v-icon class="btn-close" @click="edit_group = -1"> close</v-icon> </v-card-title>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols=4><v-text-field :rules="sizeRules" label="Name" v-model="processed_group.group_name"></v-text-field></v-col>
                                            <v-col cols=3><v-text-field :rules="sizeRules" label="Group key" v-model="processed_group.group_key"></v-text-field></v-col>
                                            <v-col cols=3><v-text-field :rules="sizeRules" label="Teacher key" v-model="processed_group.teacher_key"></v-text-field></v-col>     
                                            <v-col cols=1><v-icon x-large color="green" @click="processGroup(-2)">done</v-icon></v-col>  
                                        </v-row>
                                    </v-card-text>
                                </v-card>                                          
                                <br>
                                <v-row justify="center">
                                    <v-icon @click="processed_group = {group_name:'', group_key:'', teacher_key:''}; edit_group = -2"> mdi-plus-circle-outline</v-icon>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="6">
                        <v-card>
                            <v-card-text>
                                <h3>My teaching groups</h3>
                                <br>
                                <v-row> 
                                    <v-col cols=4><b>Group name</b></v-col>
                                    <v-col cols=2><b>Group key</b></v-col>
                                    <v-col cols=2><b>Key for teachers</b></v-col>
                                    <v-col cols=4><v-checkbox v-model="selectedArchivedTeaching" label = "show archived"></v-checkbox></v-col>
                                </v-row>
                                <div v-for="(group, index) in content.teaching_groups" :key="index">
                                    <v-row v-if="!group.archived || selectedArchivedTeaching">
                                        <v-col cols=4>{{group.group_name}}<span v-if="group.archived"> (archived)</span></v-col>
                                        <v-col cols=2 v-if="show_key != group.id" @click="show_key = show_key>-1?-1:group.id">
                                            <v-icon title="Show key">mdi-eye-outline</v-icon>
                                        </v-col>                                        
                                        <v-col cols=2 v-if="show_key == group.id">
                                            {{group.group_key}} <v-icon @click="show_key =-1">close</v-icon>
                                        </v-col>                                        
                                        <v-col cols=2 v-if="show_teacher_key != group.id" @click="show_teacher_key = show_teacher_key>-1?-1:group.id">
                                            <v-icon title="Show teacher key">mdi-eye-outline</v-icon>
                                        </v-col>                                        
                                        <v-col cols=2 v-if="show_teacher_key == group.id">
                                            {{group.teacher_key}} <v-icon @click="show_teacher_key =-1">close</v-icon>
                                        </v-col>                                        
                                        <v-col cols=4>
                                            <v-btn class="background-transparent" x-small dense @click ="stopTeaching(group.id)">stop teaching</v-btn>
                                            <v-btn class="background-transparent" x-small dense @click="archiveGroup('teaching',group)">
                                                <span v-if="!group.archived">archive</span>
                                                <span v-if="group.archived">unarchive</span>                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </div>
                                <br>
                                <v-card v-if="new_teach">
                                    <v-card-title>Select group<v-icon class="btn-close" @click="new_teach = false"> close</v-icon> </v-card-title>
                                    <v-card-text>
                                        <v-autocomplete @input="addToTeacherGroups()"
                                                                    v-model="groups2"
                                                                    :items="teaching_groups"
                                                                    :search-input.sync="search2"
                                                                    hide-selected
                                                                    label="Add groups"
                                                                    multiple
                                                                    small-chips
                                                                ></v-autocomplete>

                                    </v-card-text>
                                </v-card>
                                    <br>
                                <v-row justify="center">
                                    <v-icon @click="prepareTeachingGroups()">mdi-plus-circle-outline</v-icon>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card> 
    </v-container>
</template>

<script>
import axios from '../axios-auth.js'
import {mapGetters} from 'vuex'

export default {
    computed: 
        mapGetters([
                    'getShowModalMessageResult'                    
                ])
    ,
    data() {
        return {
            content : null,
            permissions: false,
            show_key: -1,
            show_teacher_key: -1,
            edit_group: -1,
            processed_group: null,
            sizeRules: [
                v => !!v || 'The value is required',
                v => (v && v.length >= 5 && v.length <= 30) || 'Use 5-30 chars.',
            ],
            error_message: '',
            new_teach: false,
            groups2: [],
            teaching_groups: [],
            teaching_groups_full: [],
            search2: null,
            addingGroup: null,
            selectedArchivedCreated: false,
            selectedArchivedTeaching : false,
            deleteGroup: null
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)    

            // get category list
            axios.get('/get-course-groups/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.content = res.data 
                    
                    if (res.data.message != 'OK') {
                        this.$store.commit('setFeedback', res.data.message)
                    } 
                    const bc = [
                        { text: res.data.category.name, href: '/areas/' + res.data.category.id },//#
                        { text: res.data.area.name, href: '/courses/' + res.data.area.id }, //#                   
                        { text: res.data.course.name, href: '/course_content/' + res.data.course.id }, //#
                        { text: "Teacher groups", href: '/course_groups/' + res.data.course.id }, //#
                    ]
                    this.$store.commit('setBreadCrumbs',bc)                        
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        processGroup(_index) {
            const _data = { 
                group_id: _index == -2 ? 0 : this.content.created_groups[_index].id,
                group_name: this.processed_group.group_name,
                group_key: this.processed_group.group_key,
                teacher_key: this.processed_group.teacher_key,
                course_id: this.$route.params.id
            }

            axios.post('/edit-course-group', _data, this.$store.getters.getAxiosConfig)
                .then(res => {                   
                    if (res.data.message != 'OK') {
                        this.$store.commit('setFeedback', res.data.message)
                    }  else {
                        if (_index > -2) {
                            // edited
                            this.content.created_groups[_index].group_name = _data.group_name
                            this.content.created_groups[_index].group_key = _data.group_key,
                            this.content.created_groups[_index].teacher_key = _data.teacher_key
                            // teached
                            for(let i = 0; i < this.content.teaching_groups.length; i++) {
                                if (this.content.teaching_groups[i].id == this.content.created_groups[_index].id) {
                                    this.content.teaching_groups[i].group_name = _data.group_name
                                    this.content.teaching_groups[i].group_key = _data.group_key,
                                    this.content.teaching_groups[i].teacher_key = _data.teacher_key
                                }
                            }
                        } else {
                            this.content.created_groups.push({id:res.data.id, group_name: _data.group_name, 
                                                              group_key:_data.group_key, teacher_key:_data.teacher_key })
                        }
                        this.edit_group = -1
                    }                                        
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        prepareTeachingGroups() {
            this.new_teach = true
            axios.get('/get-all-teacher-course-groups/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.teaching_groups = []
                    this.full_teaching_groups = []
                    res.data.teaching_groups.forEach(el => { 
                        if (!this.isTeached(el.id)) {
                            this.teaching_groups.push(el.group_name)
                            this.full_teaching_groups.push({id: el.id, group_name: el.group_name})
                        }
                    });
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        addToTeacherGroups() {
            const _group_name = this.groups2[0]
            this.groups2 = []

            // if it is in my group - away - probably never
            for(let i=0; i<this.content.teaching_groups.length; i++) {
                if (this.content.teaching_groups[i].group_name == _group_name) {
                    const _index = this.teaching_groups.indexOf(_group_name)
                    this.full_teaching_groups.splice(_index,1)
                    this.teaching_groups.splice(_index,1)
                    return
                }
            }

            this.addingGroup = null
            for(let i=0; i<this.full_teaching_groups.length; i++) {
                if (this.full_teaching_groups[i].group_name == _group_name) {
                    this.addingGroup = {
                        id : this.full_teaching_groups[i].id,
                        group_name: this.full_teaching_groups[i].group_name
                    }
                }
            }

            if (this.addingGroup == null) return
            if (!this.isOwner(this.addingGroup)) {
                this.$store.commit('setShowModalMessage',
                            {content: '"'+_group_name+'" is a teaching group. Type teacher key.', type: 'warning', 
                             buttons:[], icons:[{text:'close', color:'red', value: 9},{text:'done', color:'green', value: 10}], input: 1})
            } else {
                this.addNewTeachingGroup(this.addingGroup, this.getTeacherKeyFromCreated(this.addingGroup.id))
            }
        },
        isOwner(_g) {
            for(let i=0; i<this.content.created_groups.length; i++) {
                if (_g.id == this.content.created_groups[i].id) return true
            }
            return false;
        },
        getTeacherKeyFromCreated(_id) {
            for(let i = 0; this.content.created_groups.length; i++) {
                if (this.content.created_groups[i].id == _id) return this.content.created_groups[i].teacher_key
            }
            return "-1"
        },
        addNewTeachingGroup(_group, _teacher_key) {
            const _data = {
                group_id: _group.id,
                teacher_key: _teacher_key,
                course_id: this.$route.params.id
            }
            axios.post('/add-teacher-to-group', _data, this.$store.getters.getAxiosConfig)
            .then(res => {                   
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                }  else {
                    if (this.full_teaching_groups != null) {
                        // delete from old list
                        for(let i=0; i<this.full_teaching_groups.length; i++) {
                            if (this.full_teaching_groups[i].id == _group.id) {
                                this.full_teaching_groups.splice(i,1)
                                this.teaching_groups.splice(i,1)
                                break;
                            }
                        }
                    }

                    // add to teaching list
                    this.content.teaching_groups.push({
                            id: _group.id,
                            group_name: _group.group_name,
                            group_key: res.data.group_key,
                            teacher_key: _teacher_key
                        })
                }                                        
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
        processModalResult() {
            const res = this.getShowModalMessageResult
            this.$store.commit('setShowModalMessageResult',null)
            if (res == 2) {
                this.deleteCreatedGroup(this.deleteGroup)
            }
            if (res == 10) {
                this.addNewTeachingGroup(this.addingGroup, this.$store.getters.getShowModalMessageText)
            }
        },
        startTeaching(_group) {
            this.addNewTeachingGroup(_group, _group.teacher_key)
        },
        stopTeaching(_id) {
            const _data = {
                group_id: _id,
                course_id: this.$route.params.id
            }
            axios.post('/stop-teaching-group', _data, this.$store.getters.getAxiosConfig)
            .then(res => {                   
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                }  else {
                    // delete from old list
                    for(let i = 0; i<this.content.teaching_groups.length; i++) {
                        if (this.content.teaching_groups[i].id == _id) {
                            this.content.teaching_groups.splice(i,1)
                            break;
                        }
                    }
                }                                        
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })

        },
        isTeached(_id) {
            for(let i=0; i<this.content.teaching_groups.length; i++) {
                if ( this.content.teaching_groups[i].id == _id) return true
            }               
            return false
        },
        archiveGroup(_type, _group) {
            const _data = {
                group_id : _group.id,
                operation_type: _type,
                course_id: this.$route.params.id
            }
            axios.post('/change-archive-group', _data, this.$store.getters.getAxiosConfig)
            .then(res => {                   
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                }  else {
                    // change in old list
                    if (_type=='created') {
                        for(let i = 0; i<this.content.created_groups.length; i++) {
                            if (this.content.created_groups[i].id == _group.id) {
                                this.content.created_groups[i].archived = !this.content.created_groups[i].archived
                                break;
                            }  
                        }                      
                    }
                    if (_type=='teaching') {
                        for(let i = 0; i<this.content.teaching_groups.length; i++) {
                            if (this.content.teaching_groups[i].id == _group.id) {
                                this.content.teaching_groups[i].archived = !this.content.teaching_groups[i].archived
                                break;
                            }
                        }
                    }
                }                                        
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })            
        },
        tryDeleteGroup(_group) {
            this.deleteGroup = _group
            this.$store.commit('setShowModalMessage',
                    {content: 'Are you sure?<br/>You want to delete group "' + _group.group_name + '".<br>It can include students.', type: 'warning', 
                    buttons:[], icons:[{text:'close', color:'red', value: 1},{text:'done', color:'green', value: 2} ]})

        },
        deleteCreatedGroup(_group) {
            const _data = {
                group_id : _group.id,
                course_id: this.$route.params.id
            }
            axios.post('/delete-course-group', _data, this.$store.getters.getAxiosConfig)
            .then(res => {                   
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                }  else {
                    this.initData()
                }                                        
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })            
        }

    }
}
</script>
